import { render, staticRenderFns } from "./CreateChannelPartnerUserPopUp.vue?vue&type=template&id=62084b18&scoped=true"
import script from "./CreateChannelPartnerUserPopUp.vue?vue&type=script&lang=js"
export * from "./CreateChannelPartnerUserPopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateChannelPartnerUserPopUp.vue?vue&type=style&index=0&id=62084b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62084b18",
  null
  
)

export default component.exports